import React, { useContext, useEffect } from "react";
import GlobalConfig from "../context/GlobalConfig";
import JourneyConfig from "../context/JourneyConfig";
import Footer from "../components/Footer";
import { languageData } from "../constants/languageData";
import Head from "./Head";
import RenderSvg from "../components/RenderSvg";
import { error } from "ajv/dist/vocabularies/applicator/dependencies";
import { trackAction } from "../utils/hyperdx";
function UnableToProcess({
  stepperFunc,
  steps,
  currentStep,
  currentDocumentStep,
  documentFailureReason,
}) {
  const reason = sessionStorage.getItem('documentFailureReason') || documentFailureReason || "";
  const language = sessionStorage.getItem("language") ?? "en";
  const isBothFrontSideGiven = reason === "ONLY_FRONT";
  const isBothBackSideGiven = reason === "ONLY_BACK";
  const { config } = useContext(GlobalConfig);
  const { branding } = config ?? {};
  const isNoDocumentRetry = Boolean(config?.routes?.[steps?.[0]]?.includes("user-details"));
  const { journey, setJourney } = useContext(JourneyConfig);

  // Retry has to relaunch the document that actually failed, not document 1. A
  // DIGILOCKER_FAILURE names its own remedy — the analysis response stashes a fresh URL for
  // exactly that document — so the reason decides first and no idType lookup can get it
  // wrong. capturedData is the fallback for the rest: it carries idType / idType2 / idType3
  // and currentDocumentStep is 0-based, so document 2's Digilocker lives under idType2.
  // Reading idType alone sent documents 2 and 3 down the camera branch, landing the
  // applicant on that document's user-details form instead of back in Digilocker.
  const currentIdTypeKey = currentDocumentStep ? `idType${currentDocumentStep + 1}` : "idType";
  const currentCountryKey = currentDocumentStep ? `country${currentDocumentStep + 1}` : "country";
  const currentIdType = journey?.capturedData?.[currentIdTypeKey];
  const isDigilockerDocument =
    reason === "DIGILOCKER_FAILURE" ||
    currentIdType === "Digilocker" ||
    currentIdType === "Digilocker 2.0";

  // Friction signal: document could not be processed (drives retry funnels).
  useEffect(() => {
    trackAction("document:unable_to_process", { reason: reason || undefined });
  }, [reason]);

  return (
    <>
      <Head
        style={{ zIndex: "100" }}
        stepperFunc={stepperFunc}
        showBackIcon={false}
        showLanguages={false}
        handleBack={() => stepperFunc(steps[2])}
      />
      <div className="parent-container">
        <div className="main">
          <div className="left-section">
            <RenderSvg
              config={config}
              id={"unable_to_process"}
              svgType={"unable_to_process"}
              className="md:w-[220px] md:h-[200px] w-[250px] h-[250px] md:relative "
              style={{ marginTop: "3rem" }}
            />
          </div>

          <div
            className="right-section md:items-start items-center"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              gap: 24,
              fontFamily: "Inter, sans-serif",

            }}
          >
            <div className="flex flex-col md:text-start text-center items-start gap-4 self-stretch">
              <div className="text-black font-inter text-2xl font-semibold self-stretch text-[18px] md:text-[28px]">
                {
                  (languageData[language]?.unableToProcess[reason] ||
                    languageData["en"]?.unableToProcess[reason])
                    ? languageData[language]?.unableToProcess[reason]
                      ?.heading ??
                    languageData["en"]?.unableToProcess[reason]?.heading
                    : languageData[language]?.unableToProcess
                      ?.heading ?? languageData["en"]?.unableToProcess?.heading}
              </div>
              <div className="text-[#656565] font-inter text-[12px] md:text-[16px] font-semibold leading-normal self-stretch">
                {
                  (languageData[language]?.unableToProcess[reason] ||
                    languageData["en"]?.unableToProcess[reason])
                    ? languageData[language]?.unableToProcess[reason]
                      ?.subHeading ??
                    languageData["en"]?.unableToProcess[reason]?.subHeading
                    : languageData[language]?.unableToProcess
                      ?.subHeading ??
                    languageData["en"]?.unableToProcess?.subHeading}
              </div>
            </div>
            <div className="flex flex-col justify-center items-center w-full">
              {/* <a href="/ChangeId" className={`hover:underline mb-2`} style={{ color: config?.branding?.accentColor }} onClick={() => onNextStep(1)}>Change ID type</a> */}
              {!(journey?.userInfo?.id?.[currentIdTypeKey] &&
                journey?.userInfo?.id?.[currentCountryKey]) && (
                  <button
                    className={"underline mb-4"}
                    style={{ color: config?.branding?.accentColor }}
                    onClick={() => {
                      sessionStorage.removeItem("documentFailureReason");
                      stepperFunc(steps[1]); // Call the first function
                      setJourney({
                        ...journey,
                        capturedData: { ...journey?.capturedData, [currentIdTypeKey]: "" },
                      }); // Call the second function
                    }}
                  >
                    {languageData[language]?.unableToProcess
                      ?.changeIDButton ??
                      languageData["en"]?.unableToProcess?.changeIDButton}
                  </button>
                )}
              <button
                className="flex flex-row items-center justify-center gap-4 w-full text-white py-4 px-4 rounded"
                style={{ backgroundColor: config?.branding?.accentColor }}
                onClick={() => {
                  if (isDigilockerDocument)
                  {
                    const digilockerUrl = sessionStorage.getItem("digilockerUrl");
                    if (digilockerUrl) {
                      // Replace with the stored URL
                      window.location.replace(digilockerUrl);
                    } else {
                      // Fallback to your stepper navigation if no URL is saved
                      stepperFunc(steps[1]);
                    }
                    sessionStorage.removeItem("documentFailureReason");
                  }
                  else if (isNoDocumentRetry) stepperFunc(steps[0]);
                  else if(sessionStorage.getItem('cameraAccessAllowed')) stepperFunc(steps[0]+1);
                  else stepperFunc(steps[1]+1);
                }}
              >
                {
                  isBothFrontSideGiven
                    ? (languageData[language]?.unableToProcess?.captureBackSide ??
                        languageData["en"]?.unableToProcess?.captureBackSide)
                    : isBothBackSideGiven
                      ? (languageData[language]?.unableToProcess?.captureFrontSide ??
                          languageData["en"]?.unableToProcess?.captureFrontSide)
                      : (
                        languageData[language]?.unableToProcess?.button ??
                        languageData["en"]?.unableToProcess?.button
                      )
                }
              </button>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UnableToProcess;
